import dayjs from 'dayjs';
import { IAidasUser } from 'app/shared/model/ainnotateservice/aidas-user.model';
import { IAidasObject } from 'app/shared/model/ainnotateservice/aidas-object.model';
import { IAidasUpload } from 'app/shared/model/ainnotateservice/aidas-upload.model';

export interface IAidasUserAidasObjectMapping {
  id?: number;
  dateAssigned?: string | null;
  status?: boolean | null;
  aidasUser?: IAidasUser;
  aidasObject?: IAidasObject;
  aidasUploads?: IAidasUpload[] | null;
}

export const defaultValue: Readonly<IAidasUserAidasObjectMapping> = {
  status: false,
};
